/* eslint-disable react/prop-types */
import React, { useReducer } from 'react';
import { func, shape, string, arrayOf, oneOf } from 'prop-types';
import { Select, Input, Button, SelectMulti } from 'htlib-copy';

import { SUPPORTED_MISSION_TYPES, BOOLEAN_SELECT_ITEMS } from 'utils/constants';
import reducer, { TYPES, INITIAL_MISSIONS_QUERY_PARAMS } from './reducer';

import './Filters.scss';

export default function Filters({ filters, setFilters }) {
  const [queryParams, dispatch] = useReducer(reducer, filters);

  return (
    <div className="Missions__filters">
      <div className="filter">
        <span className="filter__name small">Mission validated</span>
        <Select
          placeholder="-"
          items={BOOLEAN_SELECT_ITEMS}
          onSelect={value => {
            dispatch({ type: TYPES.checkValidated, payload: value });
          }}
          selectedValue={queryParams.checkValidated}
        />
      </div>

      <div className="filter">
        <span className="filter__name small">Mission type</span>
        <SelectMulti
          placeholder="-"
          items={SUPPORTED_MISSION_TYPES}
          checkedItems={queryParams.labelingType || []}
          onSelect={value => {
            dispatch({ type: TYPES.labelingType, payload: value });
          }}
        />
      </div>
      <div className="filter">
        <span className="filter__name small">Mission checked</span>
        <Select
          placeholder="-"
          items={BOOLEAN_SELECT_ITEMS}
          onSelect={value => {
            dispatch({ type: TYPES.missionChecked, payload: value });
          }}
          selectedValue={queryParams.missionChecked}
        />
      </div>
      <div className="filter">
        <span className="filter__name small">Mission started</span>
        <Select
          placeholder="-"
          items={BOOLEAN_SELECT_ITEMS}
          onSelect={value => {
            dispatch({ type: TYPES.atleastonedone, payload: value });
          }}
          selectedValue={queryParams.atleastonedone}
        />
      </div>
      <div className="filter">
        <span className="filter__name small">Mission name</span>
        <Input
          value={queryParams.name}
          placeholder="mission name"
          onChange={({ target: { value } }) => {
            dispatch({ type: TYPES.name, payload: value });
          }}
        />
      </div>
      <div />
      <div className="Missions__fetch">
        <Button
          type="danger"
          ghost
          onClick={() => {
            dispatch({ type: TYPES.reset });
            setFilters(INITIAL_MISSIONS_QUERY_PARAMS);
          }}
        >
          Clear
        </Button>

        <Button
          type="primary"
          onClick={() => {
            setFilters(queryParams);
          }}
        >
          Search
        </Button>
      </div>
    </div>
  );
}

Filters.propTypes = {
  filters: shape({
    missionChecked: string,
    atleastonedone: string,
    checkValidated: string,
    name: string,
    labelingType: arrayOf(oneOf(SUPPORTED_MISSION_TYPES)),
  }).isRequired,
  setFilters: func.isRequired,
};
